import { defineQuery } from 'next-sanity'

export const videoHeroFields = `
  _id,
  _type,
  title,
  "video": video.asset->,
  startTime,
  endTime
`

export const VIDEO_HERO_QUERY = defineQuery(/* groq */ `
  *[_type == "video-hero"][0]{
    ${videoHeroFields}
  }
`)
